webpackJsonp([21693109666204],{

/***/ 1061:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{}}

/***/ })

});


// WEBPACK FOOTER //
// path---layouts-gallery-a0e39f21c11f6a62c5ab.js